module.exports = __webpack_public_path__ + "img/2.59a7c6e4.jpg";